import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Input,
  Dropdown,
  Button,
  FormGroup,
  FormField,
  Icon
} from 'semantic-ui-react'

const CardDrugContinuePlanUX = (props: any) => {
    return(
      <div>
        <div
          id="CardDrugContinuePlanUX-div-98"
          style={{ height: "45px" , padding: "0 5px"}}>

          <div
            id="CardDrugContinuePlanUX-div-239"
            style={{display: "grid", gridTemplateColumns: "repeat(4, 200px)", columnGap: "10px", marginTop: "10px"}}>

            <div
              id="CardDrugContinuePlanUX-div-240">

              <Button
                className={props.drugContinueFilter?.status === "only_open" ? "fluid" : "basic fluid"}
                color="blue"
                id="CardDrugContinuePlanUX-Button-244"
                name="only_open"
                onClick={props.onSetdrugContinueFilter}
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Unclosed items only" : "เฉพาะรายการที่ยังไม่ปิด"}
              </Button>
            </div>
            <div
              id="CardDrugContinuePlanUX-div-241">

              <Button
                className={props.drugContinueFilter?.status === "only_new" ? "fluid" : "basic fluid"}
                color="blue"
                id="CardDrugContinuePlanUX-Button-245"
                name="only_new"
                onClick={props.onSetdrugContinueFilter}
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "New items only" : "เฉพาะรายการใหม่"}
              </Button>
            </div>
            <div
              id="CardDrugContinuePlanUX-div-242">

              <Button
                className={props.drugContinueFilter?.status === "only_active" ? "fluid" : "basic fluid"}
                color="blue"
                id="CardDrugContinuePlanUX-Button-246"
                name="only_active"
                onClick={props.onSetdrugContinueFilter}
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Current items only" : "เฉพาะรายการปัจจุบัน"}
              </Button>
            </div>
            <div
              id="CardDrugContinuePlanUX-div-243">

              <Button
                className={props.drugContinueFilter?.status === "all" ? "fluid" : "basic fluid"}
                color="blue"
                id="CardDrugContinuePlanUX-Button-247"
                name="all"
                onClick={props.onSetdrugContinueFilter}
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Show all" : "แสดงทั้งหมด"}
              </Button>
            </div>
          </div>
        </div>
        <Table
          NoDataComponent={props.noDataComponent}
          data={props.drugContinuePlanItems}
          getTdProps={props.getDrugListTdProps}
          getTrProps={props.drugListProps}
          headers="Drug, Dose, Unit, Route, Site, Frequency,PRN, Qty, Status, Action"
          id="CardDrugContinuePlanUX-Table-1"
          keys="title_status, dose, unitText, routeText, siteText, frequencyText,prn, qty, status,action"
          minRows="10"
          showPagination={false}
          style={{height:"45vh", padding: "0 5px", display: "none"}}
          widths=",80,80,,130,130, 80,80,,80">
        </Table>
        <div
          id="CardDrugContinuePlanUX-div-234">
          {props.tableElement}
        </div>
        <div
          className="ui form"
          id="CardDrugContinuePlanUX-div-140"
          style={{padding:"15px", ...(props.hidePanel && {display: "none"})}}>

          <FormGroup
            id="CardDrugContinuePlanUX-FormGroup-141"
            style={{marginBottom: "0.5rem"}}>
            <FormField
              id="CardDrugContinuePlanUX-FormField-145"
              inline={true}
              width={5}>
              <div
                id="CardDrugContinuePlanUX-div-6">
                <div
                  id="CardDrugContinuePlanUX-div-4"
                  style={{marginRight:"10px"}}>
                  {props.languageUX === "en" ? "Drug" : "ยา"}
                </div>
                <div
                  id="CardDrugContinuePlanUX-div-12"
                  style={{width: "100%"}}>
                  {props.drugSearchBox}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-152"
              inline={true}>
              <div
                id={props.languageUX === "en" ? "" : "CardDrugContinuePlanUX-div-135"}>

                <div
                  id="CardDrugContinuePlanUX-div-169"
                  style={{minWidth:"40px"}}>
                  {"\u00a0"}
                </div>
                <Button
                  color={props.hasFactsheetData ? "blue" : undefined}
                  disabled={!props.hasFactsheetData}
                  fluid={true}
                  id="CardDrugContinuePlanUX-Button-136"
                  onClick={props.onClickDrugFact}>
                  {props.languageUX === "en" ? "DRUG FACT" : "ข้อมูลยา"}
                </Button>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-235">
              <label
                id="CardDrugContinuePlanUX-label-236">
                {"\u00a0"}
              </label>
              <div
                id="CardDrugContinuePlanUX-div-237">
                {props.calculatorIcon}
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-155"
              inline={true}>
              <div
                id="CardDrugContinuePlanUX-div-202">
                {"\u00a0"}
              </div>
              <Button
                basic={!props.modSolventSelectionConfig?.activeButtonSolvent}
                color={props.modSolventSelectionConfig?.showButtonSolvent ?"blue": "grey"}
                disabled={!props.modSolventSelectionConfig?.showButtonSolvent }
                id="CardDrugContinuePlanUX-Button-203"
                onClick={props.onOpenModSolventSelection}
                style={{cursor: props.modSolventSelectionConfig?.activeButtonSolvent || typeof props.modSolventSelectionConfig?.admixtureIndex === "number"?"auto":"pointer"}}>
                {props.languageUX === "en" ? "SOLVENT" : "ตัวทำละลาย"}
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugContinuePlanUX-FormGroup-142">
            <FormField
              id="CardDrugContinuePlanUX-FormField-153"
              inline={true}
              width={3}>
              <div
                id="CardDrugContinuePlanUX-div-132">

                <label
                  id="CardDrugContinuePlanUX-label-133"
                  style={{minWidth:"40px"}}>
                  {props.languageUX === "en" ? "Dose" : "ปริมาณยา"}
                </label>
                <label
                  id="CardDrugContinuePlanUX-label-134"
                  style={{ display: props.DrugSelectSequence?.require_unit ? "" : "none", color: "red" }}>
                  *
                </label>
                <Input
                  disabled={!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes("REQUEST") || props.DrugSelectSequence?.allowed_actions?.includes("EDIT")) ? false : true}
                  fluid={true}
                  id="CardDrugContinuePlanUX-Input-14"
                  loading={props.loadingPreviews}
                  name="dose"
                  onChange={props.onPreviewDrugContinuePlan}
                  value={props.DrugSelectSequence?.dose || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-154"
              inline={true}
              width={3}>
              <div
                id="CardDrugContinuePlanUX-div-15">

                <label
                  id="CardDrugContinuePlanUX-label-127"
                  style={{minWidth:"55px"}}>
                  {props.languageUX === "en" ? "Unit" : "หน่วย"}
                </label>
                <label
                  id="CardDrugContinuePlanUX-label-128"
                  style={{ display: props.DrugSelectSequence?.require_unit ? "" : "none", color: "red" }}>
                   *
                </label>
                <Dropdown
                  className="inline-label"
                  clearable={true}
                  disabled={!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes("REQUEST") || props.DrugSelectSequence?.allowed_actions?.includes("EDIT")) ? false : true}
                  fluid={true}
                  id="CardDrugContinuePlanUX-Dropdown-25"
                  loading={props.loadingPreviews}
                  name="unit"
                  onChange={props.onPreviewDrugContinuePlan}
                  options={props.drugUnits}
                  search={true}
                  selection={true}
                  value={props.DrugSelectSequence?.unit || ""}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-157"
              inline={true}
              width={3}>
              <div
                id="CardDrugContinuePlanUX-div-21">

                <label
                  id="CardDrugContinuePlanUX-label-123"
                  style={{minWidth:"40px"}}>
                  {props.languageUX === "en" ? "Route" : "วิธีให้ยา"}
                </label>
                <label
                  id="CardDrugContinuePlanUX-label-124"
                  style={{ display: props.DrugSelectSequence?.require_route ? "" : "none", color: "red" }}>
                   *
                </label>
                <Dropdown
                  className="inline-label"
                  clearable={true}
                  disabled={!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes("REQUEST") || props.DrugSelectSequence?.allowed_actions?.includes("EDIT")) ? false : true}
                  fluid={true}
                  id="CardDrugContinuePlanUX-Dropdown-28"
                  loading={props.loadingPreviews}
                  name="route"
                  onChange={props.onPreviewDrugContinuePlan}
                  options={props.drugRoutes}
                  search={true}
                  selection={true}
                  value={props.DrugSelectSequence?.route || ""}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-156"
              inline={true}
              width={3}>
              <div
                id="CardDrugContinuePlanUX-div-19">

                <label
                  id="CardDrugContinuePlanUX-label-125"
                  style={{minWidth:"40px"}}>
                  {props.languageUX === "en" ? "Site" : "ตำแหน่ง"}
                </label>
                <label
                  id="CardDrugContinuePlanUX-label-126"
                  style={{ display: props.DrugSelectSequence?.require_site ? "" : "none", color: "red" }}>
                   *
                </label>
                <Dropdown
                  className="inline-label"
                  clearable={true}
                  disabled={!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes("REQUEST") || props.DrugSelectSequence?.allowed_actions?.includes("EDIT")) ? false : true}
                  fluid={true}
                  id="CardDrugContinuePlanUX-Dropdown-27"
                  loading={props.loadingPreviews}
                  name="site"
                  onChange={props.onPreviewDrugContinuePlan}
                  options={props.drugSites}
                  search={true}
                  selection={true}
                  value={props.DrugSelectSequence?.site || ""}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-158"
              inline={true}
              style={{ display: "none" }}
              width={3}>
              <div
                id="CardDrugContinuePlanUX-div-23">

                <label
                  id="CardDrugContinuePlanUX-label-121"
                  style={{minWidth:"55px"}}>
                  {props.languageUX === "en" ? "Method" : "วิธี"}
                </label>
                <label
                  id="CardDrugContinuePlanUX-label-122"
                  style={{ display: props.DrugSelectSequence?.require_method ? "" : "none", color: "red" }}>
                   *
                </label>
                <Dropdown
                  className="inline-label"
                  clearable={true}
                  disabled={!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes("REQUEST") || props.DrugSelectSequence?.allowed_actions?.includes("EDIT")) ? false : true}
                  fluid={true}
                  id="CardDrugContinuePlanUX-Dropdown-29"
                  loading={props.loadingPreviews}
                  name="method"
                  onChange={props.onPreviewDrugContinuePlan}
                  options={props.drugMethods}
                  search={true}
                  selection={true}
                  value={props.DrugSelectSequence?.method || ""}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-159"
              inline={true}
              width={4}>
              <div
                id="CardDrugContinuePlanUX-div-17">

                <label
                  id="CardDrugContinuePlanUX-label-119"
                  style={{minWidth:"75px"}}>
                  {props.languageUX === "en" ? "Frequency" : "ความถี่"}
                </label>
                <label
                  id="CardDrugContinuePlanUX-label-120"
                  style={{ display: props.DrugSelectSequence?.require_frequency ? "" : "none", color: "red" }}>
                   *
                </label>
                <Dropdown
                  className="inline-label"
                  clearable={true}
                  disabled={!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes("REQUEST") || props.DrugSelectSequence?.allowed_actions?.includes("EDIT")) ? false : true}
                  fluid={true}
                  id="CardDrugContinuePlanUX-Dropdown-26"
                  loading={props.loadingPreviews}
                  name="frequency"
                  onChange={props.onPreviewDrugContinuePlan}
                  options={props.drugFrequencies}
                  search={true}
                  selection={true}
                  value={props.DrugSelectSequence?.frequency || ""}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-167"
              inline={true}
              style={{alignItems: "center", display: "flex",  justifyContent: "center"}}
              width={1}>
              <div
                id="CardDrugContinuePlanUX-div-166"
                style={{ display: "none" }}>

                <div
                  id="CardDrugContinuePlanUX-div-174"
                  style={{marginTop: "-0.15rem"}}>
                  {"\u00a0"}
                </div>
                <Button
                  className="circular"
                  color="green"
                  icon="clipboard list"
                  id="CardDrugContinuePlanUX-Button-139"
                  onClick={props.onDrugDescription}
                  style={{ padding: "0.5rem 0.59rem 0.6rem", fontSize: "1.45rem"}}>
                </Button>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugContinuePlanUX-FormGroup-175">
            <FormField
              id="CardDrugContinuePlanUX-FormField-177"
              width="8">
              <div
                id="CardDrugContinuePlanUX-div-182">

                <div
                  id="CardDrugContinuePlanUX-div-183">
                  {props.languageUX === "en" ? "PRN" : "PRN"}
                </div>
                <Dropdown
                  allowAdditions={!!props.DrugSelectSequence?.code}
                  clearable={true}
                  fluid={true}
                  id="CardDrugContinuePlanUX-Dropdown-238"
                  name="prn"
                  onAddItem={props.onAdditionPrn}
                  onChange={props.onUnPreviewDrugContinuePlan}
                  options={props.prnOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.DrugSelectSequence?.prn || ""}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-178"
              width="7">
              <div
                id="CardDrugContinuePlanUX-div-185">

                <div
                  id="CardDrugContinuePlanUX-div-186">
                  {props.languageUX === "en" ? "Additional drug use details" : "รายละเอียดการใช้ยาเพิ่มเติม"}
                </div>
                <Input
                  fluid={true}
                  id="CardDrugContinuePlanUX-Input-197"
                  name="description"
                  onChange={props.onUnPreviewDrugContinuePlan}
                  value={props.DrugSelectSequence?.description || ""}>
                </Input>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            className="--override-disabled --grey"
            id="CardDrugContinuePlanUX-FormGroup-204"
            style={{display: props.isRequireRate? "": "none",marginBottom: "0.5rem"}}>
            <FormField
              id="CardDrugContinuePlanUX-FormField-205"
              width={2}>
              <div
                id="CardDrugContinuePlanUX-div-209"
                style={{marginBottom: "-1px"}}>
                {props.dripRateLabel}
              </div>
              <Input
                disabled={props.modSolventSelectionConfig?.dripRate !== "rate"}
                fluid={true}
                id="CardDrugContinuePlanUX-Input-211"
                name="mixture_iv_rate"
                onChange={props.onChangeModData}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                type="number"
                value={props.modSolventSelectionConfig?.mixture_iv_rate}>
              </Input>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-206"
              width={2}>
              <label
                id="CardDrugContinuePlanUX-label-213">
                {"\u00a0"}
              </label>
              <Dropdown
                className="inline-label"
                clearable={true}
                disabled={props.modSolventSelectionConfig?.dripRate !== "rate"}
                fluid={true}
                id="CardDrugContinuePlanUX-Dropdown-215"
                name="mixture_iv_rate_unit"
                onChange={props.onChangeModData}
                options={props.modSolventSelectionConfig?.ivRateOptions || []}
                search={true}
                selection={true}
                value={props.modSolventSelectionConfig?.mixture_iv_rate_unit}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-207"
              width={2}>
              <div
                id="CardDrugContinuePlanUX-div-210"
                style={{marginBottom: "-1px"}}>
                {props.dripDurationLabel}
              </div>
              <Input
                disabled={props.modSolventSelectionConfig?.dripRate === "rate"}
                fluid={true}
                id="CardDrugContinuePlanUX-Input-212"
                name="drug_drip_in"
                onChange={props.onChangeModData}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                type="number"
                value={props.modSolventSelectionConfig?.drug_drip_in}>
              </Input>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-208"
              width={2}>
              <label
                id="CardDrugContinuePlanUX-label-214">
                {"\u00a0"}
              </label>
              <Dropdown
                className="inline-label"
                clearable={true}
                disabled={props.modSolventSelectionConfig?.dripRate === "rate"}
                fluid={true}
                id="CardDrugContinuePlanUX-Dropdown-216"
                name="drug_drip_in_unit"
                onChange={props.onChangeModData}
                options={props.modSolventSelectionConfig?.dripInOptions || []}
                search={true}
                selection={true}
                value={props.modSolventSelectionConfig?.drug_drip_in_unit}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugContinuePlanUX-FormGroup-176">
            <FormField
              id="CardDrugContinuePlanUX-FormField-179"
              style={{display: "flex", alignItems: "center"}}
              width="3">
              <div
                id="CardDrugContinuePlanUX-div-188">

                <div
                  id="CardDrugContinuePlanUX-div-189">
                  {props.languageUX === "en" ? "est." : "est."}
                </div>
                <label
                  id="CardDrugContinuePlanUX-label-201">
                  {props.DrugSelectSequence?.calculated_daily_quantity}
                </label>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-180"
              width="3">
              <div
                id="CardDrugContinuePlanUX-div-191">

                <div
                  id="CardDrugContinuePlanUX-div-192">
                  {props.languageUX === "en" ? "qty." : "จำนวน"}
                </div>
                <Input
                  fluid={true}
                  id="CardDrugContinuePlanUX-Input-199"
                  loading={props.loadingPreviews}
                  name="sending_quantity"
                  onChange={props.onUnPreviewDrugContinuePlan}
                  value={props.DrugSelectSequence?.sending_quantity || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-181"
              width="4">
              <div
                id="CardDrugContinuePlanUX-div-194">

                <div
                  id="CardDrugContinuePlanUX-div-195">
                  {props.languageUX === "en" ? "Number of exempted days" : "จำนวนวันที่ยกเว้นการจ่าย"}
                </div>
                <Input
                  fluid={true}
                  id="CardDrugContinuePlanUX-Input-200"
                  loading={props.loadingPreviews}
                  name="sending_interval"
                  onChange={props.onUnPreviewDrugContinuePlan}
                  value={props.DrugSelectSequence?.sending_interval || ""}>
                </Input>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugContinuePlanUX-FormGroup-217"
            style={{display: props.hideSolvent? "none": "",marginBottom: "0.5rem"}}>
            <FormField
              id="CardDrugContinuePlanUX-FormField-218"
              style={{ border: "1px solid rgba(34,36,38,.15)",borderRight: "none", paddingTop: "1rem", paddingBottom: "1rem" }}
              width={6}>
              <label
                id="CardDrugContinuePlanUX-label-223">
                {props.languageUX === "en" ? "Solvent" : "ตัวทำละลาย"}
              </label>
              <div
                id="CardDrugContinuePlanUX-div-224">
                {props.searchBoxSolvent}
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-219"
              style={{ border: "1px solid rgba(34,36,38,.15)",borderRight: "none", paddingTop: "1rem", paddingBottom: "1rem" , borderLeft: "none"}}
              width={2}>
              <label
                id="CardDrugContinuePlanUX-label-225">
                {props.languageUX === "en" ? "Volume (For mixing)" : "ปริมาตร (สำหรับการผสม)"}
              </label>
              <Input
                fluid={true}
                id="CardDrugContinuePlanUX-Input-226"
                name="volume"
                onChange={props.onChangeModData}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                type="number"
                value={props.modSolventSelectionConfig?.volume ?? ""}>
              </Input>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-220"
              style={{ border: "1px solid rgba(34,36,38,.15)",borderRight: "none", paddingTop: "1rem", paddingBottom: "1rem" , borderLeft: "none"}}
              width={2}>
              <label
                id="CardDrugContinuePlanUX-label-227">
                {props.languageUX === "en" ? "Unit (of volume)" : "หน่วย (ปริมาตร)"}
              </label>
              <Dropdown
                className="inline-label"
                fluid={true}
                id="CardDrugContinuePlanUX-Dropdown-228"
                name="unit"
                onChange={props.onChangeModData}
                options={props.unitOptions}
                search={true}
                selection={true}
                value={props.modSolventSelectionConfig?.unit || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-221"
              style={{ border: "1px solid rgba(34,36,38,.15)",borderRight: "none", paddingTop: "1rem", paddingBottom: "1rem" , borderLeft: "none"}}
              width={2}>
              <label
                id="CardDrugContinuePlanUX-label-229"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Total Qty (per dispense)" : "ปริมาณรวม (ต่อครั้ง)"}
              </label>
              <Input
                fluid={true}
                id="CardDrugContinuePlanUX-Input-230"
                name="quantity"
                onChange={props.onChangeModData}
                onKeyDown={(e: any)=> ["-","e"].includes(e.key) && e.preventDefault()}
                type="number"
                value={props.modSolventSelectionConfig?.quantity ?? ""}>
              </Input>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-222"
              style={{ border: "1px solid rgba(34,36,38,.15)",borderLeft: "none", paddingTop: "1rem", paddingBottom: "1rem", position: "relative", flex:1, marginRight: "0.75rem" }}>
              <div
                id="CardDrugContinuePlanUX-div-231"
                style={{position: "absolute", top: "0", right: "0.25rem", display: typeof props.modSolventSelectionConfig?.admixtureIndex === "number"?"none":""}}>

                <Icon
                  className="red small"
                  id="CardDrugContinuePlanUX-Icon-232"
                  link={true}
                  name="close"
                  onClick={props.onCloseButtonSolvent}>
                </Icon>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-233"
              width="1">
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugContinuePlanUX-FormGroup-144"
            inline={true}
            style={{marginTop: "1.5rem"}}>
            <FormField
              id="CardDrugContinuePlanUX-FormField-148"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-164">
              <div
                id="CardDrugContinuePlanUX-div-81"
                style={{display:"flex", alignItems: "center"}}>
                <div
                  id="CardDrugContinuePlanUX-div-79"
                  style={{marginRight:"10px"}}>
                  {props.languageUX === "en" ? "Continuity (of medication)" : "ความต่อเนื่อง (การให้ยา)"}
                </div>
                <Button
                  color="yellow"
                  icon="edit"
                  id="CardDrugContinuePlanUX-Button-83"
                  onClick={props.onOpenModPlanning}>
                </Button>
              </div>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-165"
              inline={true}>
              <div
                id="CardDrugContinuePlanUX-div-80">
                {props.planningData?.date_time_summary}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugContinuePlanUX-FormGroup-149"
            style={{marginTop:"2rem"}}>
            <FormField
              id="CardDrugContinuePlanUX-FormField-150"
              inline={true}
              width={2}>
            </FormField>
            <FormField
              id="CardDrugContinuePlanUX-FormField-151"
              inline={true}>
              <div
                id="CardDrugContinuePlanUX-div-9"
                style={{display:"flex"}}>
                <Button
                  color="grey"
                  id="CardDrugContinuePlanUX-Button-95"
                  onClick={props.onClearDrugOrderForm}
                  size="small">
                  {props.languageUX === "en" ? "Clear data" : "ล้างข้อมูล"}
                </Button>
                <Button
                  id="CardDrugContinuePlanUX-Button-96"
                  name="NOTE"
                  onClick={props.onNoteAndVerifyAndCancelDrugContinuePlan}
                  size="small"
                  style={{ display: props.DrugSelectSequence?.allowed_actions?.includes("NOTE") ? "" : "none" }}>
                  {props.languageUX === "en" ? "NOTE" : "บันทึก"}
                </Button>
                <div
                  id="CardDrugContinuePlanUX-div-129">
                  {props.buttonEdit}
                </div>
                <div
                  id="CardDrugContinuePlanUX-div-130">
                  {props.buttonEditQuantity}
                </div>
                <Button
                  color="red"
                  id="CardDrugContinuePlanUX-Button-87"
                  name="CANCEL"
                  onClick={props.onNoteAndVerifyAndCancelDrugContinuePlan}
                  size="small"
                  style={{ display: props.buttonActions?.cancel?.show ? "" : "none" }}>
                  {props.languageUX === "en" ? "CANCEL" : "ยกเลิก"}
                </Button>
                <div
                  id="CardDrugContinuePlanUX-div-131">
                  {props.buttonRequest}
                </div>
                <Button
                  color="red"
                  id="CardDrugContinuePlanUX-Button-88"
                  name="REJECT"
                  onClick={props.onNoteAndVerifyAndCancelDrugContinuePlan}
                  size="small"
                  style={{ display: props.buttonActions?.reject?.show ? "" : "none" }}>
                  {props.languageUX === "en" ? "REJECT" : "ปฏิเสธ"}
                </Button>
                <Button
                  color="green"
                  id="CardDrugContinuePlanUX-Button-89"
                  name="VERIFY"
                  onClick={props.onNoteAndVerifyAndCancelDrugContinuePlan}
                  size="small"
                  style={{ display: props.buttonActions?.verify?.show ? "" : "none" }}>
                  {props.languageUX === "en" ? "VERIFY" : "ตรวจสอบ"}
                </Button>
                <Button
                  color="orange"
                  id="CardDrugContinuePlanUX-Button-109"
                  onClick={props.onOpenModSpecialDirection}
                  size="small"
                  style={{ display: props.modSpecialDirectionConfig?.showButton ? "" : "none" }}>
                  {props.languageUX === "en" ? "Details of how to use the medicine" : "รายละเอียดวิธีการใช้ยา"}
                </Button>
                <Button
                  color="yellow"
                  id="CardDrugContinuePlanUX-Button-110"
                  onClick={props.onOpenModSolventSelection}
                  size="small"
                  style={{ display: "none" }}>
                  {props.languageUX === "en" ? "Select a solvent" : "เลือกตัวทำละลาย"}
                </Button>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardDrugContinuePlanUX-div-171"
          style={{display: props.openCalCulator ? "inline" : "none", position:"absolute", width:"70%", height:"180px", right:"16px", top:"10px", backgroundColor:"red"}}>
          {props.pediatricUI}
        </div>
      </div>
    )
}


export default CardDrugContinuePlanUX

export const screenPropsDefault = {"language":"TH","showSearchResult":true}

/* Date Time : Fri Feb 06 2026 09:23:13 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 1,
      "name": "Table",
      "parent": 0,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "props.noDataComponent"
        },
        "data": {
          "type": "code",
          "value": "props.drugContinuePlanItems"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getDrugListTdProps"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.drugListProps"
        },
        "headers": {
          "type": "value",
          "value": "Drug, Dose, Unit, Route, Site, Frequency,PRN, Qty, Status, Action"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Table-1"
        },
        "keys": {
          "type": "value",
          "value": "title_status, dose, unitText, routeText, siteText, frequencyText,prn, qty, status,action"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:\"45vh\", padding: \"0 5px\", display: \"none\"}"
        },
        "widths": {
          "type": "value",
          "value": ",80,80,,130,130, 80,80,,80"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "ยา",
          "valueEN": "Drug"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"10px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 145,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-6"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 151,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Input",
      "parent": 132,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes(\"REQUEST\") || props.DrugSelectSequence?.allowed_actions?.includes(\"EDIT\")) ? false : true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Input-14"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingPreviews"
        },
        "name": {
          "type": "value",
          "value": "dose"
        },
        "onChange": {
          "type": "code",
          "value": "props.onPreviewDrugContinuePlan"
        },
        "value": {
          "type": "code",
          "value": "props.DrugSelectSequence?.dose || \"\""
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-15"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-17"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-19"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 157,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-21"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 158,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-23"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Dropdown",
      "parent": 15,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes(\"REQUEST\") || props.DrugSelectSequence?.allowed_actions?.includes(\"EDIT\")) ? false : true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Dropdown-25"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingPreviews"
        },
        "name": {
          "type": "value",
          "value": "unit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onPreviewDrugContinuePlan"
        },
        "options": {
          "type": "code",
          "value": "props.drugUnits"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.DrugSelectSequence?.unit || \"\""
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Dropdown",
      "parent": 17,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes(\"REQUEST\") || props.DrugSelectSequence?.allowed_actions?.includes(\"EDIT\")) ? false : true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Dropdown-26"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingPreviews"
        },
        "name": {
          "type": "value",
          "value": "frequency"
        },
        "onChange": {
          "type": "code",
          "value": "props.onPreviewDrugContinuePlan"
        },
        "options": {
          "type": "code",
          "value": "props.drugFrequencies"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.DrugSelectSequence?.frequency || \"\""
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Dropdown",
      "parent": 19,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes(\"REQUEST\") || props.DrugSelectSequence?.allowed_actions?.includes(\"EDIT\")) ? false : true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Dropdown-27"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingPreviews"
        },
        "name": {
          "type": "value",
          "value": "site"
        },
        "onChange": {
          "type": "code",
          "value": "props.onPreviewDrugContinuePlan"
        },
        "options": {
          "type": "code",
          "value": "props.drugSites"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.DrugSelectSequence?.site || \"\""
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Dropdown",
      "parent": 21,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes(\"REQUEST\") || props.DrugSelectSequence?.allowed_actions?.includes(\"EDIT\")) ? false : true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Dropdown-28"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingPreviews"
        },
        "name": {
          "type": "value",
          "value": "route"
        },
        "onChange": {
          "type": "code",
          "value": "props.onPreviewDrugContinuePlan"
        },
        "options": {
          "type": "code",
          "value": "props.drugRoutes"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.DrugSelectSequence?.route || \"\""
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Dropdown",
      "parent": 23,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.DrugSelectSequence?.id ? false : props.DrugSelectSequence?.id && (props.DrugSelectSequence?.allowed_actions?.includes(\"REQUEST\") || props.DrugSelectSequence?.allowed_actions?.includes(\"EDIT\")) ? false : true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Dropdown-29"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingPreviews"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onChange": {
          "type": "code",
          "value": "props.onPreviewDrugContinuePlan"
        },
        "options": {
          "type": "code",
          "value": "props.drugMethods"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.DrugSelectSequence?.method || \"\""
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": "ความต่อเนื่อง (การให้ยา)",
          "valueEN": "Continuity (of medication)"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"10px\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 165,
      "props": {
        "children": {
          "type": "code",
          "value": "props.planningData?.date_time_summary"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-80"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 164,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-81"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "Button",
      "parent": 81,
      "props": {
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "icon": {
          "type": "value",
          "value": "edit"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-83"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenModPlanning"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "CANCEL"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-87"
        },
        "name": {
          "type": "value",
          "value": "CANCEL"
        },
        "onClick": {
          "type": "code",
          "value": "props.onNoteAndVerifyAndCancelDrugContinuePlan"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.buttonActions?.cancel?.show ? \"\" : \"none\" }"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "ปฏิเสธ",
          "valueEN": "REJECT"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "disabled": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-88"
        },
        "name": {
          "type": "value",
          "value": "REJECT"
        },
        "onClick": {
          "type": "code",
          "value": "props.onNoteAndVerifyAndCancelDrugContinuePlan"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.buttonActions?.reject?.show ? \"\" : \"none\" }"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "ตรวจสอบ",
          "valueEN": "VERIFY"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-89"
        },
        "name": {
          "type": "value",
          "value": "VERIFY"
        },
        "onClick": {
          "type": "code",
          "value": "props.onNoteAndVerifyAndCancelDrugContinuePlan"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.buttonActions?.verify?.show ? \"\" : \"none\" }"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างข้อมูล",
          "valueEN": "Clear data"
        },
        "color": {
          "type": "value",
          "value": "grey"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-95"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClearDrugOrderForm"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "NOTE"
        },
        "disabled": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-96"
        },
        "name": {
          "type": "value",
          "value": "NOTE"
        },
        "onClick": {
          "type": "code",
          "value": "props.onNoteAndVerifyAndCancelDrugContinuePlan"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.DrugSelectSequence?.allowed_actions?.includes(\"NOTE\") ? \"\" : \"none\" }"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"45px\" , padding: \"0 5px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดวิธีการใช้ยา",
          "valueEN": "Details of how to use the medicine"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-109"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenModSpecialDirection"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.modSpecialDirectionConfig?.showButton ? \"\" : \"none\" }"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกตัวทำละลาย",
          "valueEN": "Select a solvent"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-110"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenModSolventSelection"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"none\" }"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "ความถี่",
          "valueEN": "Frequency"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-119"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"75px\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": " *"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-120"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.DrugSelectSequence?.require_frequency ? \"\" : \"none\", color: \"red\" }"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "วิธี",
          "valueEN": "Method"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-121"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"55px\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": " *"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-122"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.DrugSelectSequence?.require_method ? \"\" : \"none\", color: \"red\" }"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "วิธีให้ยา",
          "valueEN": "Route"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-123"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"40px\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": " *"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-124"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.DrugSelectSequence?.require_route ? \"\" : \"none\", color: \"red\" }"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำแหน่ง",
          "valueEN": "Site"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-125"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"40px\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": " *"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-126"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.DrugSelectSequence?.require_site ? \"\" : \"none\", color: \"red\" }"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วย",
          "valueEN": "Unit"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-127"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"55px\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": " *"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-128"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.DrugSelectSequence?.require_unit ? \"\" : \"none\", color: \"red\" }"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonEdit"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-129"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonEditQuantity"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-130"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonRequest"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-131"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 153,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-132"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "label",
      "parent": 132,
      "props": {
        "children": {
          "type": "value",
          "value": "ปริมาณยา",
          "valueEN": "Dose"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-133"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"40px\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "label",
      "parent": 132,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-134"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.DrugSelectSequence?.require_unit ? \"\" : \"none\", color: \"red\" }"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 152,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-135",
          "valueEN": ""
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "Button",
      "parent": 135,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลยา",
          "valueEN": "DRUG FACT"
        },
        "color": {
          "type": "code",
          "value": "props.hasFactsheetData ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": "!props.hasFactsheetData"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-136"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickDrugFact"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "Button",
      "parent": 166,
      "props": {
        "className": {
          "type": "value",
          "value": "circular"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "value",
          "value": "clipboard list"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-139"
        },
        "onClick": {
          "type": "code",
          "value": "props.onDrugDescription"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0.5rem 0.59rem 0.6rem\", fontSize: \"1.45rem\"}"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-140"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"15px\", ...(props.hidePanel && {display: \"none\"})}"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormGroup",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormGroup-141"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormGroup",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormGroup-142"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "FormGroup",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormGroup-144"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1.5rem\"}"
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-145"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "FormField",
      "parent": 144,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-148"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "FormGroup",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormGroup-149"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"2rem\"}"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "FormField",
      "parent": 149,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-150"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 151,
      "name": "FormField",
      "parent": 149,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-151"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 152,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-152"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-153"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-154"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-155"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 156,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-156"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-157"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-158"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"none\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-159"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "FormField",
      "parent": 144,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-164"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "FormField",
      "parent": 144,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-165"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 167,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-166"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"none\" }"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "FormField",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-167"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{alignItems: \"center\", display: \"flex\",  justifyContent: \"center\"}"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 135,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-169"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"40px\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pediatricUI"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-171"
        },
        "style": {
          "type": "code",
          "value": "{display: props.openCalCulator ? \"inline\" : \"none\", position:\"absolute\", width:\"70%\", height:\"180px\", right:\"16px\", top:\"10px\", backgroundColor:\"red\"}"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "div",
      "parent": 166,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-174"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"-0.15rem\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "FormGroup",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormGroup-175"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 176,
      "name": "FormGroup",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormGroup-176"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 177,
      "name": "FormField",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-177"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 178,
      "name": "FormField",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-178"
        },
        "width": {
          "type": "value",
          "value": "7"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 179,
      "name": "FormField",
      "parent": 176,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-179"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 180,
      "name": "FormField",
      "parent": 176,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-180"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 181,
      "name": "FormField",
      "parent": 176,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-181"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "div",
      "parent": 177,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-182"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "div",
      "parent": 182,
      "props": {
        "children": {
          "type": "value",
          "value": "PRN",
          "valueEN": "PRN"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-183"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 185,
      "name": "div",
      "parent": 178,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-185"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 186,
      "name": "div",
      "parent": 185,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการใช้ยาเพิ่มเติม",
          "valueEN": "Additional drug use details"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-186"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "div",
      "parent": 179,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-188"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 188,
      "props": {
        "children": {
          "type": "value",
          "value": "est.",
          "valueEN": "est."
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-189"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 191,
      "name": "div",
      "parent": 180,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-191"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "div",
      "parent": 191,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวน",
          "valueEN": "qty."
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-192"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": null,
      "id": 194,
      "name": "div",
      "parent": 181,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-194"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": null,
      "id": 195,
      "name": "div",
      "parent": 194,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนวันที่ยกเว้นการจ่าย",
          "valueEN": "Number of exempted days"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-195"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "Input",
      "parent": 185,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Input-197"
        },
        "name": {
          "type": "value",
          "value": "description"
        },
        "onChange": {
          "type": "code",
          "value": "props.onUnPreviewDrugContinuePlan"
        },
        "value": {
          "type": "code",
          "value": "props.DrugSelectSequence?.description || \"\""
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 199,
      "name": "Input",
      "parent": 191,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Input-199"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingPreviews"
        },
        "name": {
          "type": "value",
          "value": "sending_quantity"
        },
        "onChange": {
          "type": "code",
          "value": "props.onUnPreviewDrugContinuePlan"
        },
        "value": {
          "type": "code",
          "value": "props.DrugSelectSequence?.sending_quantity || \"\""
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 200,
      "name": "Input",
      "parent": 194,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Input-200"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingPreviews"
        },
        "name": {
          "type": "value",
          "value": "sending_interval"
        },
        "onChange": {
          "type": "code",
          "value": "props.onUnPreviewDrugContinuePlan"
        },
        "value": {
          "type": "code",
          "value": "props.DrugSelectSequence?.sending_interval || \"\""
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": null,
      "id": 201,
      "name": "label",
      "parent": 188,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DrugSelectSequence?.calculated_daily_quantity"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-201"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": null,
      "id": 202,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-202"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 203,
      "name": "Button",
      "parent": 155,
      "props": {
        "basic": {
          "type": "code",
          "value": "!props.modSolventSelectionConfig?.activeButtonSolvent"
        },
        "children": {
          "type": "value",
          "value": "ตัวทำละลาย",
          "valueEN": "SOLVENT"
        },
        "color": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.showButtonSolvent ?\"blue\": \"grey\""
        },
        "disabled": {
          "type": "code",
          "value": "!props.modSolventSelectionConfig?.showButtonSolvent "
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-203"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenModSolventSelection"
        },
        "style": {
          "type": "code",
          "value": "{cursor: props.modSolventSelectionConfig?.activeButtonSolvent || typeof props.modSolventSelectionConfig?.admixtureIndex === \"number\"?\"auto\":\"pointer\"}"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 204,
      "name": "FormGroup",
      "parent": 140,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormGroup-204"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isRequireRate? \"\": \"none\",marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 205,
      "name": "FormField",
      "parent": 204,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-205"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 206,
      "name": "FormField",
      "parent": 204,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-206"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 206,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 207,
      "name": "FormField",
      "parent": 204,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-207"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 207,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 208,
      "name": "FormField",
      "parent": 204,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-208"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": null,
      "id": 209,
      "name": "div",
      "parent": 205,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dripRateLabel"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-209"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"-1px\"}"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": null,
      "id": 210,
      "name": "div",
      "parent": 207,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dripDurationLabel"
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-210"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"-1px\"}"
        }
      },
      "seq": 210,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 211,
      "name": "Input",
      "parent": 205,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.dripRate !== \"rate\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Input-211"
        },
        "name": {
          "type": "value",
          "value": "mixture_iv_rate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.mixture_iv_rate"
        }
      },
      "seq": 211,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 212,
      "name": "Input",
      "parent": 207,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.dripRate === \"rate\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Input-212"
        },
        "name": {
          "type": "value",
          "value": "drug_drip_in"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.drug_drip_in"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": null,
      "id": 213,
      "name": "label",
      "parent": 206,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-213"
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": null,
      "id": 214,
      "name": "label",
      "parent": 208,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-214"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 215,
      "name": "Dropdown",
      "parent": 206,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.dripRate !== \"rate\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Dropdown-215"
        },
        "name": {
          "type": "value",
          "value": "mixture_iv_rate_unit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "options": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.ivRateOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.mixture_iv_rate_unit"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 216,
      "name": "Dropdown",
      "parent": 208,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.dripRate === \"rate\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Dropdown-216"
        },
        "name": {
          "type": "value",
          "value": "drug_drip_in_unit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "options": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.dripInOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.drug_drip_in_unit"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 217,
      "name": "FormGroup",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormGroup-217"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideSolvent? \"none\": \"\",marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 218,
      "name": "FormField",
      "parent": 217,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-218"
        },
        "style": {
          "type": "code",
          "value": "{ border: \"1px solid rgba(34,36,38,.15)\",borderRight: \"none\", paddingTop: \"1rem\", paddingBottom: \"1rem\" }"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 219,
      "name": "FormField",
      "parent": 217,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-219"
        },
        "style": {
          "type": "code",
          "value": "{ border: \"1px solid rgba(34,36,38,.15)\",borderRight: \"none\", paddingTop: \"1rem\", paddingBottom: \"1rem\" , borderLeft: \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 220,
      "name": "FormField",
      "parent": 217,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-220"
        },
        "style": {
          "type": "code",
          "value": "{ border: \"1px solid rgba(34,36,38,.15)\",borderRight: \"none\", paddingTop: \"1rem\", paddingBottom: \"1rem\" , borderLeft: \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 220,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 221,
      "name": "FormField",
      "parent": 217,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-221"
        },
        "style": {
          "type": "code",
          "value": "{ border: \"1px solid rgba(34,36,38,.15)\",borderRight: \"none\", paddingTop: \"1rem\", paddingBottom: \"1rem\" , borderLeft: \"none\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 221,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 222,
      "name": "FormField",
      "parent": 217,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-222"
        },
        "style": {
          "type": "code",
          "value": "{ border: \"1px solid rgba(34,36,38,.15)\",borderLeft: \"none\", paddingTop: \"1rem\", paddingBottom: \"1rem\", position: \"relative\", flex:1, marginRight: \"0.75rem\" }"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": null,
      "id": 223,
      "name": "label",
      "parent": 218,
      "props": {
        "children": {
          "type": "value",
          "value": "ตัวทำละลาย",
          "valueEN": "Solvent"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-223"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": null,
      "id": 224,
      "name": "div",
      "parent": 218,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchBoxSolvent"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-224"
        }
      },
      "seq": 224,
      "void": false
    },
    {
      "from": null,
      "id": 225,
      "name": "label",
      "parent": 219,
      "props": {
        "children": {
          "type": "value",
          "value": "ปริมาตร (สำหรับการผสม)",
          "valueEN": "Volume (For mixing)"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-225"
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 226,
      "name": "Input",
      "parent": 219,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Input-226"
        },
        "name": {
          "type": "value",
          "value": "volume"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.volume ?? \"\""
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": null,
      "id": 227,
      "name": "label",
      "parent": 220,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วย (ปริมาตร)",
          "valueEN": "Unit (of volume)"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-227"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 228,
      "name": "Dropdown",
      "parent": 220,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Dropdown-228"
        },
        "name": {
          "type": "value",
          "value": "unit"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "options": {
          "type": "code",
          "value": "props.unitOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.unit || \"\""
        }
      },
      "seq": 228,
      "void": false
    },
    {
      "from": null,
      "id": 229,
      "name": "label",
      "parent": 221,
      "props": {
        "children": {
          "type": "value",
          "value": "ปริมาณรวม (ต่อครั้ง)",
          "valueEN": "Total Qty (per dispense)"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-229"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 230,
      "name": "Input",
      "parent": 221,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Input-230"
        },
        "name": {
          "type": "value",
          "value": "quantity"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeModData"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any)=> [\"-\",\"e\"].includes(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.modSolventSelectionConfig?.quantity ?? \"\""
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": null,
      "id": 231,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-231"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", top: \"0\", right: \"0.25rem\", display: typeof props.modSolventSelectionConfig?.admixtureIndex === \"number\"?\"none\":\"\"}"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 232,
      "name": "Icon",
      "parent": 231,
      "props": {
        "className": {
          "type": "value",
          "value": "red small"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Icon-232"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCloseButtonSolvent"
        }
      },
      "seq": 232,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 233,
      "name": "FormField",
      "parent": 217,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-233"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": null,
      "id": 234,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.tableElement"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-234"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 235,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-FormField-235"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 236,
      "name": "label",
      "parent": 235,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-label-236"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": null,
      "id": 237,
      "name": "div",
      "parent": 235,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculatorIcon"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-237"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 238,
      "name": "Dropdown",
      "parent": 182,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "!!props.DrugSelectSequence?.code"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Dropdown-238"
        },
        "name": {
          "type": "value",
          "value": "prn"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAdditionPrn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onUnPreviewDrugContinuePlan"
        },
        "options": {
          "type": "code",
          "value": "props.prnOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugSelectSequence?.prn || \"\""
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": null,
      "id": 239,
      "name": "div",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-239"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", gridTemplateColumns: \"repeat(4, 200px)\", columnGap: \"10px\", marginTop: \"10px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 240,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-240"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": null,
      "id": 241,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-241"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 242,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-242"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": null,
      "id": 243,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-div-243"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 244,
      "name": "Button",
      "parent": 240,
      "props": {
        "children": {
          "type": "value",
          "value": "เฉพาะรายการที่ยังไม่ปิด",
          "valueEN": "Unclosed items only"
        },
        "className": {
          "type": "code",
          "value": "props.drugContinueFilter?.status === \"only_open\" ? \"fluid\" : \"basic fluid\""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-244"
        },
        "name": {
          "type": "value",
          "value": "only_open"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetdrugContinueFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 245,
      "name": "Button",
      "parent": 241,
      "props": {
        "children": {
          "type": "value",
          "value": "เฉพาะรายการใหม่",
          "valueEN": "New items only"
        },
        "className": {
          "type": "code",
          "value": "props.drugContinueFilter?.status === \"only_new\" ? \"fluid\" : \"basic fluid\""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-245"
        },
        "name": {
          "type": "value",
          "value": "only_new"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetdrugContinueFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 246,
      "name": "Button",
      "parent": 242,
      "props": {
        "children": {
          "type": "value",
          "value": "เฉพาะรายการปัจจุบัน",
          "valueEN": "Current items only"
        },
        "className": {
          "type": "code",
          "value": "props.drugContinueFilter?.status === \"only_active\" ? \"fluid\" : \"basic fluid\""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-246"
        },
        "name": {
          "type": "value",
          "value": "only_active"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetdrugContinueFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 247,
      "name": "Button",
      "parent": 243,
      "props": {
        "children": {
          "type": "value",
          "value": "แสดงทั้งหมด",
          "valueEN": "Show all"
        },
        "className": {
          "type": "code",
          "value": "props.drugContinueFilter?.status === \"all\" ? \"fluid\" : \"basic fluid\""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugContinuePlanUX-Button-247"
        },
        "name": {
          "type": "value",
          "value": "all"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetdrugContinueFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 247,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardDrugContinuePlanUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH",
    "showSearchResult": true
  },
  "width": 80
}

*********************************************************************************** */
